import { render, staticRenderFns } from "./InBox.vue?vue&type=template&id=7acba6a4&"
import script from "./InBox.vue?vue&type=script&lang=js&"
export * from "./InBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports